export function getHomePath() {
    return '/'
}
export function getAboutUsPath() {
    return '/about-us'
}

export function getMembershipPath() {
    return '/membership'
}
export function getSingleProductPath(slug: string) {
    return `/product/${slug}`
}
export function getCategoriesPath() {
    return '/shop'
}
/** Filters `/shop` by brand slug (`CategoryContentWrapper`). */
export function getShopBrandPath(brandSlug: string) {
    return `${getCategoriesPath()}?brand=${encodeURIComponent(brandSlug)}`
}
/** Filters `/shop` by parent category slug; optional child uses `sub_category`. */
export function getShopCategoryPath(categorySlug: string, subCategorySlug?: string) {
    const params = new URLSearchParams({ category: categorySlug })
    if (subCategorySlug) {
        params.set('sub_category', subCategorySlug)
    }
    return `${getCategoriesPath()}?${params.toString()}`
}
export function getCartPath() {
    return '/cart'
}
export function getOrderConfirmedPath() {
    return '/cart/order-confirmed'
}
export function getContactUsPath() {
    return '/contact-us'
}
export function getPrivacyPolicyPath() {
    return '/privacy-policy'
}
export function getTermsAndConditionsPath() {
    return '/terms-and-conditions'
}
export function getRefundPolicyPath() {
    return '/refund-policy'
}
export function getShippingPolicyPath() {
    return '/shipping-policy'
}
export function getCookiePolicyPath() {
    return '/cookie-policy'
}
export function getFaqPath() {
    return '/faq'
}
export function getBlogsPath() {
    return '/our-stories'
}
export function getSingleBlogPath(slug: string) {
    return `/our-stories/${slug}`
}
export function getUserDashboardPath() {
    return '/dashboard'
}
export function getMyOrdersPath() {
    return '/dashboard/orders'
}
export function getSingleOrderDetailsPath(orderId: string) {
    return `/dashboard/orders/${orderId}`
}
export function getReturnReplacementPath(orderId: string) {
    return `/dashboard/orders/${orderId}/return-replacement`
}
export function getWishlistPath() {
    return '/dashboard/wishlist'
}
export function getSavedAddressesPath() {
    return '/dashboard/addresses'
}
export function getHelpAndSupportPath() {
    return '/dashboard/help'
}